import { render } from "./table_import_export.vue?vue&type=template&id=96506d10&scoped=true"
import script from "./table_import_export.vue?vue&type=script&lang=js"
export * from "./table_import_export.vue?vue&type=script&lang=js"

import "./table_import_export.vue?vue&type=style&index=0&id=96506d10&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96506d10"]])

export default __exports__